import React, {ReactNode} from 'react'
import styled from 'styled-components'
import {StyledDiv} from '../../../../../../styledComponents/StyledTypeDefinitions'

interface Props {
    item: string | ReactNode
    pageOrientation?: PageOrientation
}

type PageOrientation = 'portrait' | 'landscape'

export const NatEncloseInParenthesis: React.FC<Props> = props => {
    const {item, pageOrientation} = props

    return (
        <>
            <PrintApplicationParenthesisContainer $isLandscape={pageOrientation === 'landscape'}>
                <ParenthesisOpen>(</ParenthesisOpen>
                {item}
                <ParenthesisClose>)</ParenthesisClose>
            </PrintApplicationParenthesisContainer>
        </>
    )

    NatEncloseInParenthesis.displayName = 'NatEncloseInParenthesis'
}

const PrintApplicationParenthesisContainer = styled.div<{ $isLandscape: boolean }>`
    display: flex;
    height: 100%;
    margin-left: auto;
    ${props => props.$isLandscape ? `
        width: 155mm
    ` : `
        width: 90mm
    `}
`

const ParenthesisOpen: StyledDiv = styled.div`
  margin-right: 3mm;
`

const ParenthesisClose: StyledDiv = styled.div`
  margin-left: auto;
  margin-top: auto;
`
